module.exports = __webpack_public_path__ + "img/Dog walk.a1e9e571.svg";